import styled from 'styled-components';
import IconButton from '../../Button/iconButton';

export const HeaderWrapper = styled.div`
    position: relative;
    word-break: break-word;
    display: flex;
    flex-direction: row;
    gap: 16px;
    align-items: center;
    padding: 24px;
`;

export const HeaderTitleWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
    flex: 1;
`;

export const HeaderTitleRow = styled.div<{ $withCloseButton: boolean }>`
    display: flex;
    align-items: center;
    box-sizing: border-box;
    min-height: 24px;
    padding-right: ${props => (props.$withCloseButton ? '36px' : '0')};
`;

export const HeaderCloseButton = styled(IconButton)`
    position: absolute;
    top: 24px;
    right: 24px;
`;
